import { render } from "./SerialTimer.vue?vue&type=template&id=c1395c9c&scoped=true"
import script from "./SerialTimer.vue?vue&type=script&lang=js"
export * from "./SerialTimer.vue?vue&type=script&lang=js"

import exportComponent from "F:\\work\\1\\s\\vue-code\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1395c9c"]])

export default __exports__